import React, { useState, useEffect } from 'react';
import { Button } from '../components/Button';
import SimpleVoiceRecorder from '../components/ui/SimpleVoiceRecorder_RTC';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

function Step3({ setStep }) {
  const axiosPrivate = useAxiosPrivate();
  // Локальное состояние аудио (БЕЗ REDUX!)
  const [audioData, setAudioData] = useState(null); // {audioId, audioUrl, size, duration}
  const [isRecording, setIsRecording] = useState(false);
  const [recordingComplete, setRecordingComplete] = useState(false);
  const [isUploadingAudio, setIsUploadingAudio] = useState(false);
  const [microphoneError, setMicrophoneError] = useState(false);
  const [showDebug, setShowDebug] = useState(false);

  // Счетчик попыток перезаписи для дебага
  const [resetCount, setResetCount] = useState(0);

  // Отладочная информация
  console.log('Step3: Текущие аудио данные:', audioData);
  console.log('Step3: recordingComplete состояние:', recordingComplete);

  // Синхронизация состояния при изменении audioData
  useEffect(() => {
    const hasAudio = !!(audioData?.audioUrl || audioData?.audioId);
    console.log('🔄 AudioData изменился - есть аудио:', hasAudio);

    if (hasAudio && !recordingComplete) {
      console.log('✅ Устанавливаем recordingComplete = true');
      setRecordingComplete(true);
    }
  }, [audioData, recordingComplete]);

  // Очистка URL при размонтировании компонента
  useEffect(() => {
    return () => {
      if (audioData?.audioUrl && audioData.audioUrl.startsWith('blob:')) {
        console.log('🗑️ Очищаем URL при размонтировании:', audioData.audioUrl);
        URL.revokeObjectURL(audioData.audioUrl);
      }
    };
  }, [audioData?.audioUrl]);

  const handleResetRecording = () => {
    const newResetCount = resetCount + 1;
    setResetCount(newResetCount);
    console.log(`💀 ЯДЕРНЫЙ СБРОС #${newResetCount}`);

    // 1. УБИВАЕМ ВСЁ локальное
    setRecordingComplete(false);
    setIsRecording(false);
    setIsUploadingAudio(false);

    // 2. АГРЕССИВНО убиваем URL
    if (audioData?.audioUrl && audioData.audioUrl.startsWith('blob:')) {
      console.log(`🔥 УБИВАЕМ URL #${newResetCount}:`, audioData.audioUrl);
      try {
        URL.revokeObjectURL(audioData.audioUrl);
      } catch (e) {
        console.log('Ошибка revoke в сбросе:', e);
      }
    }

    // 3. ОЧИСТКА локального состояния
    setAudioData(null);

    // 4. Если больше 2 попыток - принудительная очистка памяти
    if (newResetCount > 2) {
      console.log(`⚠️ ПОПЫТКА #${newResetCount} - ПРИНУДИТЕЛЬНАЯ ОЧИСТКА ПАМЯТИ`);
      setTimeout(() => {
        if (window.gc) {
          window.gc();
        }
        console.log(`🧹 ПРИНУДИТЕЛЬНАЯ ОЧИСТКА ЗАВЕРШЕНА #${newResetCount}`);
      }, 100);
    }

    console.log(`✅ ЯДЕРНЫЙ СБРОС #${newResetCount} ЗАВЕРШЕН`);
  };

  // Сохранение аудио в профиль при переходе на следующий шаг
  const saveAudioToProfile = async () => {
    if (!audioData?.audioId) {
      console.log('⚠️ Нет audioId для сохранения');
      setStep(4);
      return;
    }

    try {
      console.log('💾 Сохранение аудио в профиль, audioId:', audioData.audioId);

      const response = await axiosPrivate.post('/audio-message/save-to-profile', {
        audioId: audioData.audioId,
      });

      console.log('✅ Аудио сохранено в профиль:', response.data);
      setStep(4);
    } catch (error) {
      console.error('❌ Ошибка сохранения аудио в профиль:', error);
      // Всё равно переходим дальше, аудио временно сохранено
      setStep(4);
    }
  };

  const handleRecordingComplete = (result) => {
    const attempt = resetCount + 1;
    console.log(`🎯 ПОПЫТКА #${attempt} - ПОЛУЧИЛИ РЕЗУЛЬТАТ:`, result);

    // Проверяем что получили правильный результат
    if (!result) {
      console.error(`❌ ПОПЫТКА #${attempt} ПРОВАЛЕНА - НЕТ РЕЗУЛЬТАТА`);
      return;
    }

    // Если это объект с сервера
    if (result.audioId) {
      console.log(`🎉 ПОПЫТКА #${attempt} УСПЕШНА - АУДИО НА СЕРВЕРЕ!`);
      console.log(`📍 Audio ID:`, result.audioId);
      console.log(`📏 Размер:`, result.size);
      console.log(`⏱️ Длительность:`, result.duration);

      // Получаем токен для URL
      let token = null;
      const authState = localStorage.getItem('authState');
      if (authState) {
        try {
          const parsed = JSON.parse(authState);
          token = parsed.auth_token;
        } catch (e) {
          console.error('Ошибка парсинга authState:', e);
        }
      }

      // Создаем URL для прослушивания с токеном
      const baseURL = 'https://api.mytadating.site/api';
      const audioUrl = token
        ? `${baseURL}/audio-message/get/${result.audioId}?token=${encodeURIComponent(token)}`
        : `${baseURL}/audio-message/get/${result.audioId}`;

      console.log(`🔗 Создан URL для прослушивания:`, audioUrl);

      // Определяем задержку в зависимости от номера попытки
      const delay = attempt <= 2 ? 150 : 300;
      console.log(`⏱️ Задержка для попытки #${attempt}: ${delay}мс`);

      setTimeout(() => {
        console.log(`📱 Устанавливаем состояния после ${delay}мс задержки`);
        setAudioData({
          audioId: result.audioId,
          audioUrl: audioUrl, // Добавляем URL для прослушивания
          size: result.size,
          duration: result.duration,
        });
        setRecordingComplete(true);
        console.log(`✅ Состояния установлены для попытки #${attempt}`);
        console.log(`✅ Аудио готово к прослушиванию по URL:`, audioUrl);
      }, delay);
    }
    // Если это fallback blob
    else if (result.size) {
      console.log(`⚠️ ПОПЫТКА #${attempt} - FALLBACK BLOB`, result.size, 'байт');

      if (result.size < 1000) {
        console.error(`❌ ПОПЫТКА #${attempt} ПРОВАЛЕНА - ПЛОХОЙ BLOB:`, result.size);
        return;
      }

      // Создаем URL из blob
      const audioUrl = URL.createObjectURL(result);
      setAudioData({
        blob: result,
        audioUrl: audioUrl,
        size: result.size,
        duration: 0,
      });
      setRecordingComplete(true);
    }
  };

  return (
    <div className="flex flex-col items-center w-full h-full overflow-y-auto overflow-x-hidden relative">
      <div className="w-full flex items-center justify-between mt-6">
        <h1 className="font-raleway font-semibold text-white text-[20px] flex-1 text-center">Аудио визитка (30 сек)</h1>
      </div>
      <h1 className="font-raleway font-light mt-2 text-white text-center text-[16px]">
        Расскажите немного о себе другим пользователям. При необходимости аудио визитку можно будет перезаписать или
        удалить
      </h1>
      {microphoneError ? (
        <div className="mt-10 text-center">
          <div className="mb-6 p-4 bg-red-900/20 border border-red-500/30 rounded-lg">
            <p className="font-raleway font-medium text-red-300 text-[16px] mb-2">Нет доступа к микрофону</p>
            <p className="font-raleway font-light text-red-200 text-[14px]">
              Разрешите доступ к микрофону в настройках браузера и попробуйте снова
            </p>
          </div>
          <button
            className="border border-[#A1F69E] text-[#A1F69E] text-[16px] px-6 py-3 rounded-lg mb-4"
            onClick={() => {
              setMicrophoneError(false);
              setRecordingComplete(false);
            }}
          >
            Попробовать снова
          </button>
        </div>
      ) : (
        <div className="flex justify-center items-center flex-col">
          <SimpleVoiceRecorder
            onRecordingStateChange={setIsRecording}
            onRecordingComplete={handleRecordingComplete}
            onUploadStateChange={setIsUploadingAudio}
            onMicrophoneError={() => setMicrophoneError(true)}
            resetCounter={resetCount}
          />
        </div>
      )}

      {recordingComplete && (
        <div className="fixed bottom-[24px] left-1/2 transform -translate-x-1/2 z-10 space-y-5">
          <button
            onClick={handleResetRecording}
            className="w-full p-[17px] border border-[#A1F69E] rounded-full flex items-center justify-center gap-4 text-white text-lg bg-[#032B2B]"
          >
            <img src="/icons/record-icon.svg" alt="record-icon" />
            Перезаписать
          </button>
          <Button onClick={saveAudioToProfile}>Далее</Button>
        </div>
      )}

      {/* Кнопка "Пропустить" */}
      {!recordingComplete &&
        (isUploadingAudio ? (
          <button className="fixed bottom-[24px] left-1/2 transform -translate-x-1/2 font-raleway font-medium text-[18px] text-white opacity-50 hover:opacity-70 transition-opacity z-10">
            Загрузка...
          </button>
        ) : (
          <button
            className="fixed bottom-[24px] left-1/2 transform -translate-x-1/2 font-raleway font-medium text-[18px] text-white opacity-50 hover:opacity-70 transition-opacity z-10"
            onClick={() => setStep(4)}
          >
            Пропустить
          </button>
        ))}
    </div>
  );
}

export default Step3;
